import styled from 'styled-components';

// @ts-nocheck
var Subtitle = styled.div.withConfig({
  displayName: "Subtitlestyle__Subtitle",
  componentId: "sc-mh3ap3-0"
})(["color:var(--color-text-subtle);font:-var(--font-body-m);"]);

export { Subtitle };
//# sourceMappingURL=Subtitle.style.js.map
